import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryItems } from '@wix/ambassador-restaurants-menus-v1-item/http';
export const fetchRestaurantsMenuItems = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  return withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkItems = [];
      let cursor = null;
      let hasNext = true;
      do {
        var _result$data$pagingMe, _result$data$pagingMe2;
        const result = await httpClient.request(queryItems({
          query: {
            cursorPaging: {
              cursor,
              limit: COMMON_PAGE_LIMIT
            },
            filter: idChunk.length > 0 ? {
              id: {
                $in: idChunk
              }
            } : undefined
          }
        }));
        chunkItems.push(...(result.data.items ?? []));
        hasNext = ((_result$data$pagingMe = result.data.pagingMetadata) == null ? void 0 : _result$data$pagingMe.hasNext) ?? false;
        cursor = ((_result$data$pagingMe2 = result.data.pagingMetadata) == null || (_result$data$pagingMe2 = _result$data$pagingMe2.cursors) == null ? void 0 : _result$data$pagingMe2.next) ?? null;
      } while (hasNext);
      return chunkItems;
    });
    const results = await Promise.all(chunkPromises);
    return results.flat();
  }, {
    errorCodesMap: {}
  });
};
//# sourceMappingURL=fetch-restaurants-menu-items.js.map